<template>
  <div class="">
    <Header :title="'账户总览'" right-content="isNo" />
    <div id="content">
      <div class="layout">
        <skeleton :row="3" :loading="accTradeInfoList.length === 0">
          <div class="form-row">
            <label>请添加X账号:</label>
            <br>
            <br>
            <input
              v-model="xId"
              class="input-item"
              :placeholder="'帐号'"
              :disabled="hasXId"
              oninput="value=value.replace(/\s+/g, '')"
            >
            <br>
            <span v-if="hasXId" style="color: red; font-size: 0.28rem;">
              **X账号不能更改，如有需要请联络客服
            </span>
          </div>
          <div class="form-row">
            <button v-if="!hasXId" type="button" class="control-button" @click="handleOnSubmit">
              保存
            </button>
            <p class="remind-text">保存后无法修改，请仔细操作</p>
          </div>
        </skeleton>
      </div>
    </div>
    <AlertPop :model="showError" :use-slot="true" button1-txt="知道了" @alertOnClose="handleErrorOnClose">
      <span style="color: red">请输入正确的X账号</span>
      <br>
      <br>
      <p>X账号为4到15个字符，由英文字母、数字或下划线(_)组成</p>
    </AlertPop>
    <AlertPop
      :model="showConfirm"
      :use-slot="true"
      button1-txt="确认"
      title="确认帐号"
      button2-txt="重新输入"
      @alertOnClose="handleConfirmClose"
      @button1Evt="handleSubmit"
      @button2Evt="handleReset"
    >
      <p>X账号为</p>
      <p style="font-size: 0.4rem; color: rgb(13, 89, 124)">{{ xId }}</p>
    </AlertPop>
    <Chat />
  </div>
</template>
<script>
import Header from '../module/Header.vue'
import AlertPop from '../module/AlertPop.vue'
import api from '@/plugins/api'
import { mapState } from 'vuex'
import { Skeleton } from 'vant'
import Chat from '../module/Chat.vue'
export default {
  name: 'AccAddX',
  components: { Header, AlertPop, Skeleton, Chat },
  data() {
    return {
      showConfirm: false,
      showError: false,
      xId: '',
      accTradeInfoList: [],
      hasXId: false,
      xIdRegex: /^[a-z0-9_]{4,15}$/i
    }
  },
  computed: {
    ...mapState({
      gts2CustomerId: (state) => state.gts2CustomerId
    })
  },
  mounted() {
    api
      .getAccTradeInfo(this.gts2CustomerId)
      .then((res) => {
        if (res.status === 200) {
          if (res.data.code === 200) {
            this.accTradeInfoList = res.data.data.accTradeInfoList
            if (this.accTradeInfoList[0].xId) {
              this.xId = this.accTradeInfoList[0].xId
              this.hasXId = true
            }
            return
          }
        }
        this.$toast.warning('资料获取失败')
      })
      .catch(() => {
        this.$toast.fail('资料获取失败')
      })
  },
  methods: {
    handleOnSubmit() {
      if (!this.xId.match(this.xIdRegex)) {
        this.showError = true
        return
      }
      if (this.accTradeInfoList[0].xId) {
        this.$toast(
          `你的X账号已被设定为 ${this.accTradeInfoList[0].xId}，不能更改。如有需要请联络客服。`
        )
        return
      }
      this.showConfirm = true
    },
    handleErrorOnClose() {
      this.showError = false
    },
    handleConfirmClose() {
      this.showConfirm = false
    },
    handleSubmit() {
      api
        .updateTwitterId(
          this.$qs.stringify({
            twitterId: this.xId.replace(/\s+/, '')
          })
        )
        .then((res) => {
          if (res.status === 200) {
            if (res.data.code === 200) {
              this.$toast.success('更新成功')
              this.hasXId = true
              return
            }
          }
          this.$toast.warning('更新可能出错')
        })
        .catch(() => {
          this.$toast.fail('更新出错')
        })
    },
    handleReset() {
      this.xId = ''
    }
  }
}
</script>
<style scoped>
.layout {
    display: flex;
    font-size: 0.36rem;
    padding: 0.3rem 0.3rem;
    min-height: 20vh;
    flex-direction: column;
}

.form-row {
    width: 100%;
    margin-top: 0.3rem;
    margin-bottom: 0.3rem;
}

.input-item {
    font-size: 0.3rem;
    padding: 0;
    width: 5rem;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 5px;
    width: 4.8rem;
    padding: 0.2rem 0.1rem;
    padding-left: 0.35rem;
    font-size: 0.3rem;
}

.control-button {
    padding: 0.15rem 0.35rem;
    font-size: 0.3rem;
    text-align: center;
    transition: all 0.3s ease-in-out;
    background-color: rgb(91, 155, 213);
    color: white;
    border-radius: 0.15rem;
    outline: none;
    border: 2px solid rgb(13, 89, 124);
}

.remind-text {
    color: grey;
    font-size: 0.25rem;
    margin-top: 0.3rem;
}

.alert-bottom button {
    width: 100%;
}
</style>
